"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfile = exports.UserProfileProvider = void 0;
var user_profile_provider_1 = require("./user-profile-provider");
Object.defineProperty(exports, "UserProfileProvider", { enumerable: true, get: function () { return user_profile_provider_1.UserProfileProvider; } });
var user_profile_1 = require("./user-profile");
Object.defineProperty(exports, "UserProfile", { enumerable: true, get: function () { return user_profile_1.UserProfile; } });
__exportStar(require("./get-primary-sales-organisation"), exports);
//# sourceMappingURL=index.js.map